import React from 'react';
import logoWithBen from '../assets/wth-logo-with-ben.webp';

/**
 * Brand logo component.
 * - variant="dark"  → default black artwork (light backgrounds)
 * - variant="light" → inverted for dark backgrounds (footer, admin sidebar)
 * - withTagline is retained for API back-compat but the new artwork already
 *   includes the "with Ben" script + "Customised Inspirational Gifts and
 *   Merchandise" tagline, so both modes render the same asset.
 */
const Logo = ({ variant = 'dark', withTagline = false, className = 'h-14', alt = 'Wear The Hope with Ben' }) => {
  const invert = variant === 'light' ? { filter: 'invert(1) brightness(2)' } : undefined;
  return (
    <img
      src={logoWithBen}
      alt={alt}
      draggable={false}
      style={{ ...invert, width: 'auto', maxWidth: 'none' }}
      className={`${className} shrink-0 select-none`}
    />
  );
};

export default Logo;
